import { URL_LIST } from 'core/store/modules/common/literals';
import type { AxiosRequestConfig } from 'axios';
import type { UserRoles } from '../../base';
import { fusionAuthRedirect } from '../fusionAuthRedirect';
import { UsersRepository } from './Users.repository';
import type { UserId } from '../../types';
import type { RoleModel } from './Role.model';

const skipRoles = (roles?: RoleModel[], skipValues?: UserRoles[]) => {
  if (!roles) return [];
  return roles.filter(role => !skipValues?.includes(role.name));
};

export class UsersService {
  usersRepo: UsersRepository = new UsersRepository();

  getUserInfo() {
    return this.usersRepo.getUserInfo();
  }

  getAll(config?: AxiosRequestConfig) {
    return this.usersRepo.getAll(config);
  }

  getRoles() {
    return this.usersRepo.getRoles();
  }

  async getRolesByRole() {
    const roles = await this.getRoles();

    return {
      getAdminResourceRoles: () => skipRoles(roles, ['admin']),
      getMemberResourceRoles: () => skipRoles(roles, ['admin', 'owner']),
      getGuestResourceRoles: () => skipRoles(roles, ['admin', 'owner', 'member']),
      getAdminInstanceRoles: () => skipRoles(roles, ['owner']),
    };
  }

  updateUserRoles(id: UserId, roles: UserRoles[]) {
    return this.usersRepo.updateUserRoles(id, roles);
  }

  updateManyUsersRoles(usersForUpdate: { userID: UserId; roles: UserRoles[] }[]) {
    return this.usersRepo.updateManyUsersRoles(usersForUpdate);
  }

  // eslint-disable-next-line class-methods-use-this
  login() {
    fusionAuthRedirect(URL_LIST.auth);
  }

  // eslint-disable-next-line class-methods-use-this
  logout() {
    fusionAuthRedirect(URL_LIST.logout, window.location.origin);
  }
}
